export class ParallaxImage extends Phaser.GameObjects.Image {
  protected offsetX: number;
  protected offsetY: number;

  constructor(scene: Phaser.Scene, x: number, y: number, offsetX: number, offsetY: number, texture: string | Phaser.Textures.Texture, frame?: string | number) {
    super(scene, x, y, texture, frame);

    this.offsetX = offsetX;
    this.offsetY = offsetY;
  }

  get OffsetX() {
    return this.offsetX;
  }

  get OffsetY() {
    return this.offsetY;
  }

  public resetX(x: number) {
    this.offsetX += x;
  }
}
